"use client";
import { SlideOverContextProvider as NanToastContextProvider } from "@notanumber/nan-component-library";

const SlideOverContextProvider = ({children}) => {
  return ( <NanToastContextProvider>{children}</NanToastContextProvider> );
}
 
export default SlideOverContextProvider;